import React, { FC, PropsWithChildren } from 'react';
import useLocalStorage from 'react-localstorage-hook';

import { DEFAULT_CHAIN_ID } from '@constants/common/chain.constants';
import {
  CURRENT_CHAIN_ID,
  SLIPPAGE_TOLERANCE,
  VIEW_ADDRESS,
} from '@constants/common/localStorage.constants';
import { DEFAULT_SLIPPAGE_PARAM } from '@constants/common/slippage.constants';

const LocalStorage: FC<PropsWithChildren> = ({ children }) => {
  useLocalStorage(SLIPPAGE_TOLERANCE, DEFAULT_SLIPPAGE_PARAM);
  useLocalStorage(CURRENT_CHAIN_ID, DEFAULT_CHAIN_ID);
  useLocalStorage(VIEW_ADDRESS, null);

  return <>{children}</>;
};

export default LocalStorage;
